import { Check } from "lucide-react";

export default function About() {
  const usps = [
    "Erfahrung als Immobilienmakler & Vermarkter",
    "Hintergrund in Wirtschaftspsychologie",
    "Verständnis für Käuferverhalten",
    "Klare Kommunikation, strukturierter Ablauf",
    "Flexibel — auch am Wochenende",
    "Realistische, vertrauensvolle Bildsprache",
  ];

  return (
    <section id="ueber-mich" data-testid="about-section" className="py-24 md:py-32 bg-[#F8F5EF] relative">
      <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
        {/* Offset image composition */}
        <div className="lg:col-span-5 relative reveal lg:pt-16">
          <div className="img-hover aspect-[4/5] overflow-hidden">
            <img
              src="/artur-baecker.jpg"
              alt="Artur Bäcker – Wertbild Immobilienfotografie"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="absolute -bottom-8 -right-6 hidden md:block bg-[#1A1A1A] text-[#F8F5EF] p-6 max-w-[220px]">
            <div className="ticker-num text-4xl text-[#FFA500]">7+</div>
            <div className="mt-2 text-[12px] leading-relaxed">Jahre Erfahrung in der Immobilien&shy;branche</div>
          </div>
        </div>

        <div className="lg:col-span-7 reveal">
          <div className="flex items-center gap-3 mb-6">
            
            <span className="overline">Über mich</span>
          </div>
          <h2 className="font-display text-5xl md:text-6xl lg:text-[72px] leading-[1.02] text-[#1A1A1A] tracking-tight">
            <span className="italic font-light">Perfektion</span> <br />
            ist die <span className="gold-text italic">Grundlage</span>.
          </h2>

          <p className="mt-10 text-[17px] md:text-[19px] leading-[1.65] text-[#2A2A2A] font-light">
            Ich verbinde hochwertige Immobilienfotografie und Videografie mit fundiertem
            Verständnis für Immobilienvermarktung. Durch meine Erfahrung als Immobilien&shy;makler
            weiß ich, worauf es bei Exposés, Portalen und Käuferansprache wirklich ankommt.
          </p>
          <p className="mt-6 text-[15px] md:text-[16px] leading-[1.7] text-[#5A5A5A] font-light">
            Mein Hintergrund in Wirtschaftspsychologie ergänzt diese Perspektive: Ich
            verstehe, wie visuelle Eindrücke Vertrauen schaffen, Emotionen auslösen und
            Entscheidungen beeinflussen.
          </p>

          <ul className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-4">
            {usps.map((u) => (
              <li key={u} className="flex items-start gap-3 text-[14px] text-[#1A1A1A]">
                <span className="mt-1 w-5 h-5 flex items-center justify-center bg-[#FFA500] shrink-0">
                  <Check size={11} className="text-[#1A1A1A]" strokeWidth={3} />
                </span>
                <span>{u}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
